
import {createApp} from 'vue'
import Tabs from './vueComponents/Tabs.vue';
import Tab from './vueComponents/Tab.vue';

export default {
    name: 'our-brands',
    _el: null,

    components : {
        Tabs,
        Tab
    },

    init() {
        const el = document.getElementById('js_our-brands');

        if (el) {
            this.run(el);
        }
    },

    run (el)
    {
        const app = createApp({
            delimiters: ['@{', '}'],

            data() {
                return {
                    activeTab : 'bobiler'
                }
            },

            methods: {
                setActiveTab(tabId) {
                    this.activeTab = tabId;
                }
            }
        });

        app.component('tabs', Tabs);
        app.component('tab', Tab);
        app.mount(el);
    }
}